<template>
    <div class="flex items-center gap-4">
        <div class="th-skeleton flex h-16 w-16 items-center justify-center rounded border-none" />

        <div class="flex flex-col gap-3">
            <p class="th-skeleton h-8 w-96 text-2xl font-semibold" />
            <div class="th-skeleton h-4 w-64 text-xs text-[#8993a4]" />
        </div>
    </div>
</template>
